module.exports = __webpack_public_path__ + "src/assets/img/ic14.7a59a81c.svg";